module.exports = __webpack_public_path__ + "static/media/kepler-mumbai.a7531ef3.png";